import { Injectable } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class PopoverLockService {
  available = true;
  popRef: NgbPopover;

  constructor() { }

  acquire(popover:NgbPopover) {
    if(this.popRef!==popover){
      this.closeExistingPopover();
    }

    this.popRef = popover;
    setTimeout(() => {
      this.available = false;
    });
  }

  release(popover:NgbPopover) {
    if(this.popRef === popover) {
      this.closeExistingPopover();
    }
    setTimeout(() => {
      this.available = true;
    });
  }
  closeExistingPopover() {
    if(this.popRef){
      this.popRef.close();
      this.popRef = null;
    }
  }
}
